import Vue from 'vue';
import VeeValidate, { Validator} from 'vee-validate';
import ru from './ru';

Vue.use(VeeValidate, { locale: 'ru' });

Validator.localize('ru', ru);
